/*
 * Visor de ampliacion. Es UNO en todo el tema.
 *
 * No es un custom element: es una clase que envuelve el <dialog> que pinta
 * `snippets/visor-obra.liquid`. La usan la galeria del portfolio y la ficha
 * de producto, que son quienes saben de donde salen las imagenes.
 *
 * Se abre con:
 *   visor.abrir(fuentes, indice, { alCerrar })
 *
 *   fuentes  [{ grande, srcset, alt }]
 *   alCerrar (indice) => void   lo que hay que hacer al cerrar, normalmente
 *                               devolver el foco a donde estaba.
 */

window.RedaVisor = class RedaVisor {
  constructor(dialogo) {
    this.dialogo = dialogo;
    this.marco = dialogo.querySelector('[data-reda-marco]');
    this.imagen = null;
    this.marcaActual = dialogo.querySelector('[data-reda-actual]');
    this.marcaTotal = dialogo.querySelector('[data-reda-total]');

    this.fuentes = [];
    this.indice = 0;
    this.alCerrar = null;
    this.abierto = false;

    dialogo.querySelector('[data-reda-anterior]').addEventListener('click', () => this.mover(-1));
    dialogo.querySelector('[data-reda-siguiente]').addEventListener('click', () => this.mover(1));
    dialogo.querySelector('[data-reda-cerrar]').addEventListener('click', () => this.cerrar());

    dialogo.addEventListener('keydown', (evento) => this.alPulsarTecla(evento));
    dialogo.addEventListener('click', (evento) => this.alPulsarFuera(evento));

    // El evento cancel es el camino de Escape y close el del resto. Se
    // escuchan los dos porque close se entrega en una tarea aparte y no
    // siempre llega cuando toca. Limpiar es idempotente: basta con que
    // salte uno de ellos.
    dialogo.addEventListener('cancel', () => this.limpiar());
    dialogo.addEventListener('close', () => this.limpiar());
  }

  /* --- Apertura y cierre --- */

  abrir(fuentes, indice, opciones) {
    if (!fuentes || fuentes.length === 0) return;

    this.fuentes = fuentes;
    this.alCerrar = (opciones || {}).alCerrar || null;

    if (this.marcaTotal) this.marcaTotal.textContent = this.numerar(fuentes.length);

    // Con una sola imagen las flechas y el contador sobran, y ademas serian
    // dos paradas de tabulacion que no hacen nada.
    this.dialogo.classList.toggle('reda-visor--solo', fuentes.length < 2);

    this.pintar(indice || 0);

    this.abierto = true;
    document.body.style.overflow = 'hidden';
    this.dialogo.showModal();
  }

  cerrar() {
    this.dialogo.close();
    this.limpiar();
  }

  limpiar() {
    if (!this.abierto) return;
    this.abierto = false;

    document.body.style.overflow = '';

    // Por el camino de Escape esto corre desde `cancel`, con el dialogo aun
    // abierto. Se cierra antes de avisar: el foco que devuelve el consumidor
    // no puede caer dentro de un modal todavia abierto.
    if (this.dialogo.open) this.dialogo.close();

    if (this.alCerrar) this.alCerrar(this.indice);
  }

  alPulsarFuera(evento) {
    // Pinchar en cualquier sitio que no sea la obra ni un control cierra.
    if (evento.target.closest('button, img')) return;
    this.cerrar();
  }

  alPulsarTecla(evento) {
    if (evento.key === 'ArrowLeft') {
      evento.preventDefault();
      this.mover(-1);
    } else if (evento.key === 'ArrowRight') {
      evento.preventDefault();
      this.mover(1);
    }
    // Escape lo gestiona <dialog> por su cuenta.
  }

  /* --- Navegacion --- */

  mover(paso) {
    const total = this.fuentes.length;
    this.pintar((this.indice + paso + total) % total);
  }

  // La imagen se crea al vuelo la primera vez. Asi el HTML no lleva nunca
  // un <img> sin src esperando a que alguien lo rellene.
  obtenerImagen() {
    if (this.imagen) return this.imagen;
    if (!this.marco) return null;

    const img = document.createElement('img');
    img.className = 'reda-visor__img';
    img.setAttribute('data-reda-img', '');
    this.marco.appendChild(img);
    this.imagen = img;
    return img;
  }

  pintar(indice) {
    const fuente = this.fuentes[indice];
    if (!fuente) return;

    const imagen = this.obtenerImagen();
    if (!imagen) return;

    this.indice = indice;

    imagen.srcset = fuente.srcset || '';
    imagen.src = fuente.grande || '';
    imagen.alt = fuente.alt || '';
    imagen.sizes = '100vw';

    if (this.marcaActual) this.marcaActual.textContent = this.numerar(indice + 1);

    this.precargar(indice - 1);
    this.precargar(indice + 1);
  }

  // Solo la anterior y la siguiente. Las demas, no.
  precargar(indice) {
    const total = this.fuentes.length;
    if (total < 2) return;

    const fuente = this.fuentes[(indice + total) % total];
    if (!fuente || fuente === this.fuentes[this.indice]) return;

    const previa = new Image();
    previa.srcset = fuente.srcset || '';
    previa.sizes = '100vw';
    previa.src = fuente.grande || '';
  }

  numerar(n) {
    return String(n).padStart(2, '0');
  }
};

/* Lee las fuentes de una lista de elementos con data-grande / data-srcset. */
window.redaFuentesDe = function (elementos) {
  return Array.from(elementos).map((el) => ({
    grande: el.dataset.grande || '',
    srcset: el.dataset.srcset || '',
    alt: el.dataset.alt || '',
  }));
};
